const UA_STORAGE_KEY = 'imagecat_ua';
const UA_HASH_RE = /^[a-f0-9]{64}$/;

let cachedUaHash: string | null = null;

function readUaStorage(): string | null {
  try {
    const value = localStorage.getItem(UA_STORAGE_KEY);
    if (value && value.length > 0 && value.length <= 512) {
      return value;
    }
  } catch {
    // ignore
  }
  return null;
}

function writeUaStorage(value: string): void {
  try {
    localStorage.setItem(UA_STORAGE_KEY, value);
  } catch {
    // ignore
  }
}

async function sha256Hex(input: string): Promise<string> {
  const data = new TextEncoder().encode(input);
  const hash = await crypto.subtle.digest('SHA-256', data);
  return [...new Uint8Array(hash)].map(b => b.toString(16).padStart(2, '0')).join('');
}

/** User-Agent снимок — после первого визита не меняется на этом устройстве. */
async function computeUaHash(): Promise<string> {
  const stored = readUaStorage();
  const ua = stored ?? navigator.userAgent;
  if (!stored) {
    writeUaStorage(ua);
  }
  return sha256Hex(ua);
}

export async function ensureDeviceUaHash(): Promise<string> {
  if (cachedUaHash && UA_HASH_RE.test(cachedUaHash)) {
    return cachedUaHash;
  }
  const hash = await computeUaHash();
  cachedUaHash = hash;
  return hash;
}

export function getDeviceUaHash(): string | null {
  return cachedUaHash;
}
